import templateUrl from 'emun.customer/customer-dashboard-toolbar.htm'
import controller from 'emun.customer/customer-dashboard-toolbar.controller'

export default {
	bindings: {
		customer: '<',
		review: '<'
	},
	controller,
	templateUrl($element, $attrs) {
		return $attrs.templateUrl || templateUrl;
	}
};